import { StatisticsPageMessages } from "@/messages/campaigns/statistics/statistics-page.messages";

export const CAMPAIGNS_TABLE_COLUMNS = (messages: StatisticsPageMessages) => [
  messages.scheduleColumn,
  messages.sentColumn,
  messages.deliveredColumn,
  messages.readColumn,
  messages.clickedColumn,
  messages.failedColumn,
  messages.optionsColumn,
];
